import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  ShippingMethod,
  type ShippingMethodConstructor,
} from './ShippingMethod'

export const ShippingMethodConstructorFactory =
  Factory.Sync.makeFactory<ShippingMethodConstructor>({
    id: Factory.each(() => faker.random.number()),
    name: Factory.each(() => faker.lorem.word()),
    description: Factory.each(() => faker.lorem.sentence()),
    active: true,
  })

export const ShippingMethodFactory = EntityFactory(
  ShippingMethod,
  ShippingMethodConstructorFactory
)
